<template>
<div>
    <section class="section_checkout-nav">
        <div class="checkout-top-nav-elements">
            <a href="#" class="logo-link w-inline-block"><img sizes="(max-width: 479px) 100vw, 64.421875px" srcset="@/assets/images/NewSelf_Logo-p-500.png 500w, @/assets/images/NewSelf_Logo-p-800.png 800w, @/assets/images/NewSelf_Logo.png 1000w" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-414"></a>
            <div class="form-nav-div-2">
                <a href="#" class="back-link-2 w-inline-block">
                    <div class="text-block-817">&lt;-</div>
                </a>
                <div class="progress-div-2">
                    <div>
                        <div class="step-text">Step 3 of 3 Checkout</div>
                    </div>
                    <div class="progress-precent-div">
                        <div class="percent-prog"></div>
                        <div class="percent-text">% Complete</div>
                    </div>
                </div>
            </div>
            <div class="checkout-help-wrap">

            </div>
        </div>
    </section>
    <section class="section_checkout-body sign-up">
        <div class="checkout-left-div signup">
            <div class="div-block-1793">
                <div class="text-block-862">Already have an account? <a href="/login?page_ref=Checkouts" class="link-48">Sign in</a>
                </div>
            </div>
            <div class="card-div">
                <div class="shipping-form-div sign-up">
                    <div class="checkout-form-header form signup">Create Your NewSelf Account<br></div>
                    <p class="paragraph-137">Take the first step to a healthier, happier, &amp; longer life.</p>
                    <div class="form-block-12 w-form">
                        <form @submit.prevent="registerUser">
                            <div class="_2-input-div city-state">
                                <input class="tf_textfield-2 half w-input" maxlength="256" v-model="user.first_name" name="First-Name-2" data-name="First Name 2" placeholder="First Name" type="text" id="First-Name-2" required>
                                <input class="tf_textfield-2 half w-input" maxlength="256" v-model="user.last_name" name="Last-Name-2" data-name="Last Name 2" placeholder="Last Name" type="text" id="Last-Name-2" required>
                            </div>
                            <input class="tf_textfield-2 w-input" maxlength="256" name="Email-Address-2" v-model="user.email" data-name="Email Address 2" placeholder="Email Address" type="email" id="Email-Address-2" required>
                            <div v-if="!submitted"> <input type="submit" class="checkout-button-2 w-button" value="Get Started"> </div>
                            <div v-else> 
                                <a href="#" class="checkout-button-2 w-button"> 
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                        <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                        </circle>
                                    </svg>
                                </a>
                            </div>
                            <div class="text-block-865">By hitting submit you agree to receive reminder emails for upcoming orders, tips, and other emails from NewSelf</div>
                        </form>
                    </div>
                    <a href="#" class="link-block-10 w-inline-block"></a>
                    <a href="#" class="link-block-10 w-inline-block"></a>
                    <a href="#" class="link-block-10 w-inline-block"></a>
                </div>
            </div>
            <div class="checkout-summary-div mobile">
                <div class="summary-top">
                    <div class="checkout-form-header">Order Summary<br></div>
                </div>
                <div class="dropdown-sum update">
                    <div class="order-summary-div">
                        <div data-delay="0" data-hover="false" class="order-dropdown w-dropdown">
                            <div class="dropdown-sum-toggle w-dropdown-toggle">
                                <div class="open-drop-text" @click="orderOpen = !orderOpen">
                                    <div class="text-block-336 step-1 update">Tap to access full order details</div>
                                    <div class="icon-19 w-icon-dropdown-toggle"  :class="{ 'w--open': orderOpen }"></div>
                                </div>
                                <!-- Replace static order content with v-for loop -->
                                <div class="order-div" v-for="item in cartFirstItem" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div">
                                                    <img :src="item.image" loading="lazy" :alt="item.name">
                                                </div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{item.name}}</div>
                                                <div class="text-block-850">{{ item.category }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{ item.retail_price }}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block" @click.prevent="removeFromCart(item.id)">
                                        <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="">
                                    </a>
                                </div>
                            </div>
                            <nav class="dropdown-summary w-dropdown-list" :class="{ 'w--open': orderOpen }">
                                <div class="order-div" v-for="item in cartItemsMinusFirst" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div"><img :src="item.image" loading="lazy" :alt="item.name"></div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{ item.name }} <br></div>
                                                <div class="text-block-850">{{ item.category }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{item.retail_price}}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block"><img src="@/assets/images/icon_trash.svg" loading="lazy" alt=""></a>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822">${{ cartDiscount.toFixed(2) }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ finalTotal.toFixed(2) }}</div>
                </div>
                <div class="summary-sub">You&#x27;ll be charged $449 Month 2 onwards.</div>
                <div class="promo-div-2">
                    <div class="form-block-11 checkout w-form">
                        <form id="email-form-7" name="email-form-7" data-name="Email Form 7" method="get" data-wf-page-id="6720ff41bbdbea61ec9d71dd" data-wf-element-id="833c6375-ffe9-0fd5-4487-e64a33e52546"><input class="tf_textfield-3 promo checkout w-input" maxlength="256" name="Promo-Code-2" data-name="Promo Code 2" placeholder="Promo Code" type="text" id="Promo-Code-2" required></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                    <div class="promo-button-div">
                        <a href="#" class="checkout-button-3 promo w-button">SUBMIT</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="checkout-right-div">
            <div class="checkout-summary-div desktop">
                <div class="summary-top desk">
                    <div class="checkout-form-header box">Order summary<br></div>
                    <div class="text-block-819">

                    </div>
                </div>
                <div class="dropdown-sum update">
                    <div class="order-summary-div">
                        <div data-delay="0" data-hover="false" class="order-dropdown  w-dropdown">
                            <div class="dropdown-sum-toggle w-dropdown-toggle">
                                <div class="order-div" v-for="item in cartItems" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div"><img :src="item.image" loading="lazy" :alt="item.name"></div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{item.name}}<br></div>
                                                <div class="text-block-850">{{item.cate}}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{ item.retail_price }}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" @click.prevent="removeFromCart(item.id)" class="link-block-66 w-inline-block"><img src="@/assets/images/icon_trash.svg" loading="lazy" alt=""></a>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822">${{ cartDiscount.toFixed(2) }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ finalTotal.toFixed(2) }}</div>
                </div>
                <div class="summary-sub"></div>

            </div>
        </div>
    </section>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';

export default {
    name: 'CheckoutComponent',
    components: {

    },
    props: ['stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            baseUrl: `${process.env.VUE_APP_API_ENDPOINT}/api`,
            orderOpen: false,
            submitted: false,
            couponValid: true,
            couponApplied: false,
            user:{
                first_name:'',
                last_name:'',
                email:''
            }
        };
    },
    computed: {
        ...mapGetters([
            'cartItems',
            'cartTotal',
            'cartDiscount'
        ]),
        canSubmit() {
            return this.cartItems.length > 0 &&
                this.termsAccepted &&
                this.ageVerified &&
                this.customerInfo.addressLine1 &&
                this.customerInfo.city &&
                this.customerInfo.state &&
                this.customerInfo.zip;
        },
        finalTotal() {
            return this.cartTotal;
        },
        amountInCents() {
            return Math.round(this.finalTotal * 100);
        },
        cartFirstItem(){
            return [this.cartItems[0]];
        },
        cartItemsMinusFirst(){
            let temp = this.cartItems;
            return temp.slice(1);
        }
    },
    mounted() {

    },
    methods: {
        ...mapActions([
            'removeFromCart',
            'updateCartQuantity',
            'clearCart'
        ]),
        async registerUser(){
            try {
                this.submitted= true;
                const response = await this.$axios.post(`${this.baseUrl}/register-user`, this.user);
                if (response.data.status === 'success') {
                    this.$store.dispatch("doLogin", response.data);
                } else if(response.data.status === 'error' && response.data.message === 'Existing user found.') {
                    this.$router.push({
                        name: 'LoginPage',
                        query: {
                            "page_ref": "Checkouts"
                        }
                    });
                }
                this.submitted= false;
            } catch (error) {
                console.error('Error validating coupon:', error);
                this.errorMessage = 'An error occurred while validating the coupon.';
            }
        },
        async validateCoupon() {
            if (this.couponApplied) return;

            try {
                const response = await window.axios.post(`${this.baseUrl}/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode
                });
                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    if (response.data.c_type == 1) {
                        this.paymentInfo.discount = response.data.c_val;
                    } else {
                        this.paymentInfo.discount = Math.round((this.people.amount * response.data.c_val) / 100);
                    }
                    this.intilizeExpress();
                } else {
                    this.couponValid = false;
                }
            } catch (error) {
                console.error('Error validating coupon:', error);
                this.errorMessage = 'An error occurred while validating the coupon.';
            }
        }
    }
};
</script>

<style scoped>
.link-block-43 {
    background-color: #fff;
}

.my-input {
    padding: 15px;
    border: 1px solid black;
    border-radius: 9px;
    margin-bottom: 15px;
    height: '55px';
}

.tf_textfield.w-input.StripeElement {
    align-content: center;
}

.strikethrough {
    text-decoration: line-through;
    text-decoration-color: red;
    text-decoration-thickness: 2px;
}

.promo-div {
    justify-content: space-between;
    display: block;
}

.form-block-10.checkout {
    width: 100%;
    display: flex;
    gap: 10px;
}

@media screen and (max-width: 479px) {
    .checkout-summary-div.mobile {
        background-color: #fff;
    }

    .order-div {
        background-color: #fff;
    }

    .order-summary-div {
        background-color: #fff;
    }
}
</style>
